<app-sidebar class="street-light-planner-sidebar-scenario">
  <ng-container sidebar-header>
    <div class="header-text">
      <span class="title">{{ 'module.energyMap.streetlightPlannerScenarioIndex.headerText' | translate }}</span>
    </div>
    <button class="btn btn-primary btn-close" (click)="triggerClose()">
      <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-white.svg" />
    </button>
  </ng-container>

  <ng-container sidebar-body>
    <div id="scenario-panel-municipality-selector" class="scenario-panel-municipality-selector">
      <label class="label">{{ 'module.energyMap.streetlightPlannerScenarioIndex.instructionText' | translate }}</label>
      <div class="municipality-list">
        <app-municipality-selection
          [showNavigationButton]="false"
          [displaySearch]="false"
          [isExpandedStyle]="true"
          [selectedToggleOption]="selectedToggleOption"
          [selectedMunicipality]="getSelectedMunicipalityText()"
          [municipalities]="uniqMunicipalities"
          (municipalityChangeEvent)="setMunicipality($event)"
        ></app-municipality-selection>
      </div>
    </div>

    <label class="label-text">{{ 'module.energyMap.streetlightPlannerScenarioIndex.chooseActionText' | translate }}</label>
    <div class="buttons">
      <button
        class="btn btn-outline-primary -border-inverted"
        (click)="toggleStreetlightEfficiencyDialog()"
        *ngIf="!!authService.permissions.STREETLIGHT_EFFICIENCY"
      >
        <span class="fa fa-sliders"></span>{{ 'module.energyMap.streetlightPlannerScenarioIndex.calculateEnergyEfficiencyText' | translate }}
      </button>
      <button
        class="btn btn-outline-primary -border-inverted"
        [class.-active]="scenario === 'new'"
        (click)="select('new'); open()"
        [disabled]="newScenarioDisabled"
      >
        <span class="fa fa-plus-square"></span>{{ 'module.energyMap.streetlightPlannerScenarioIndex.newScenarioText' | translate }}
      </button>
      <button class="btn btn-outline-primary -border-inverted" [class.-active]="scenario === 'open'" (click)="select('open'); open()">
        <span class="fa fa-folder-open"></span>{{ 'module.energyMap.streetlightPlannerScenarioIndex.openScenarioText' | translate }}
      </button>
    </div>
  </ng-container>

  <ng-container sidebar-footer>
    <button class="btn btn-outline-primary -border-inverted btn-previous" (click)="triggerClose()">
      {{ 'module.energyMap.streetlightPlannerScenarioIndex.cancelText' | translate }}
    </button>
  </ng-container>
</app-sidebar>
